import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import React from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  labels: [
    'LP (20%)',
    'Presale (20%)',
    'CEX (10%)',
    'Team (10%)',
    'Marketing (10%)',
    'Development (15%)',
    'Mining Rewards (5%)',
    'Staking (5%)',
    'Ecosystem Growth (5%)'
  ],
  datasets: [
    {
      data: [20, 20, 10, 10, 10, 15, 5, 5, 5],
      backgroundColor: [
        "#8e53f6",
        "#9a67ea",
        "#a67ade",
        "#b28fd0",
        "#28d6a5",
        "#36e2b3",
        "#44eec1",
        "#52facf",
        "#60ffdd"
      ],
      borderWidth: 0,
    },
  ],
};

const TokenChart = () => {
  return (
    <div className="d-flex justify-content-center">
      <div
        style={{
          width: "320px",
          height: "320px",
        }}
      >
        <Doughnut data={data} />
      </div>
    </div>
  );
};

export default TokenChart;